import React from 'react';
import { colors, type, space, radius, elevation, formatMoney, engagementLevel } from '../tokens';
import Avatar from './Avatar';

const MemberCard = ({ member, role, isPrimary, isSelected, onClick, onMakePrimary }) => {
  const level = member.engagementScore != null ? engagementLevel(member.engagementScore) : null;
  return (
    <div
      onClick={onClick}
      style={{
        background: colors.surface,
        border: `1px solid ${isSelected ? colors.brand : colors.border}`,
        borderRadius: radius.md,
        padding: space[3],
        cursor: onClick ? 'pointer' : 'default',
        boxShadow: isSelected ? elevation.cardHover : elevation.card,
        minWidth: 200,
        flex: 1,
        position: 'relative',
        transition: 'border-color 160ms',
      }}
    >
      {isPrimary && (
        <span style={{
          position: 'absolute',
          top: -8, left: space[3],
          background: colors.brand, color: '#fff',
          padding: '1px 8px', borderRadius: radius.pill,
          ...type.micro, fontWeight: 700, letterSpacing: 0.3,
        }}>
          PRIMARY
        </span>
      )}
      <div style={{ display: 'flex', gap: space[3], alignItems: 'center' }}>
        <Avatar initials={member.avatarInitials} color={member.avatarColor} size="md" />
        <div style={{ minWidth: 0 }}>
          <div style={{ ...type.body, fontWeight: 700, color: colors.textPrimary }}>
            {member.firstName} {member.lastName}
          </div>
          <div style={{ ...type.small, color: colors.textTertiary }}>
            {role}{member.age != null && ` · age ${member.age}`}
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: space[3] }}>
        <div>
          <div style={{ ...type.label, color: colors.textTertiary }}>Lifetime</div>
          <div style={{ ...type.body, fontWeight: 700, color: colors.textPrimary }}>
            {formatMoney(member.lifetimeGiving, { compact: true })}
          </div>
        </div>
        <div>
          <div style={{ ...type.label, color: colors.textTertiary }}>Gifts</div>
          <div style={{ ...type.body, fontWeight: 700, color: colors.textPrimary }}>
            {member.numberOfGifts != null ? member.numberOfGifts : '—'}
          </div>
        </div>
        {level && (
          <div>
            <div style={{ ...type.label, color: colors.textTertiary }}>Engagement</div>
            <div style={{ ...type.body, fontWeight: 700, color: level.color }}>
              {level.label}
            </div>
          </div>
        )}
      </div>
      {onMakePrimary && !isPrimary && (
        <button
          onClick={(e) => { e.stopPropagation(); onMakePrimary(member.id); }}
          style={{
            marginTop: space[3],
            width: '100%',
            padding: `${space[1]}px ${space[2]}px`,
            background: 'transparent',
            color: colors.brand,
            border: `1px solid ${colors.brand}`,
            borderRadius: radius.sm,
            ...type.micro,
            fontWeight: 700,
            fontFamily: 'inherit',
            cursor: 'pointer',
          }}
        >
          Make primary
        </button>
      )}
    </div>
  );
};

const HouseholdRoster = ({ members = [], roles = {}, primaryId, onSelect, onMakePrimary, selectedId }) => (
  <div style={{ display: 'flex', gap: space[3], flexWrap: 'wrap' }}>
    {members.map(m => (
      <MemberCard
        key={m.id}
        member={m}
        role={roles[m.id] || ''}
        isPrimary={m.id === primaryId}
        isSelected={m.id === selectedId}
        onClick={onSelect ? () => onSelect(m.id) : undefined}
        onMakePrimary={onMakePrimary}
      />
    ))}
  </div>
);

export default HouseholdRoster;
